<template>
  <section class="product-resume">
    <div class="content-devx margin-half">
      <div class="main-title-content">
        {{ $t("productResume.productResume") }}
      </div>
      <div class="card-body main">
        <section v-if="!isViewing" class="area margin-bottom-block">
          <div class="dx-field justify-content-end">
            <div class="margin-right-block">
              {{ $t("productResume.area") }}
            </div>
            <div>
              <DxNumberBox :read-only="true" :value="getArea" format="#0.00" />
            </div>
          </div>
        </section>
        <section class="content-separatos product-table">
          <DxDataGrid
            name="productResumeGrid"
            :class="[
              !isViewing
                ? 'data-grid-product-resume'
                : 'data-grid-balance-value',
            ]"
            :data-source="productResume"
            :row-alternation-enabled="true"
            :word-wrap-enabled="true"
            :show-borders="true"
            :on-editing-start="onEditingStart"
            v-on="
              !isViewing
                ? { cellPrepared: onCellPrepared }
                : { cellPrepared: onCellPreparedViewing }
            "
          >
            <DxEditing :allow-updating="true" mode="cell" />
            <DxColumn
              data-field="product"
              :caption="$t('productResume.product')"
              :allow-editing="false"
              :allow-sorting="false"
              :width="250"
            />

            <DxColumn
              v-if="!isNew"
              :caption="$t('productResume.dosageUnit')"
              data-field="dosageUnit"
              data-type="number"
              alignment="center"
              :allow-editing="false"
              :allow-sorting="false"
            />

            <DxColumn v-if="isNew" caption="Dosis unitaria" alignment="center">
              <DxColumn
                :caption="getUnit === 1 ? 'Kg/ha' : 'g/pie'"
                data-field="dosageUnitKg"
                data-type="number"
                alignment="right"
                :allow-editing="false"
                :allow-sorting="false"
              />
              <DxColumn
                :caption="getUnit === 1 ? 'L/ha' : 'cm3/pie'"
                data-field="dosageUnitL"
                data-type="number"
                alignment="right"
                :allow-editing="false"
                :allow-sorting="false"
              />
            </DxColumn>

            <DxColumn
              v-if="!isNew && showPlantColumn"
              :caption="$t('productResume.dosagePlant')"
              data-field="dosagePlant"
              data-type="number"
              alignment="right"
              :allow-editing="false"
              :allow-sorting="false"
            />
            <DxColumn
              v-if="isNew && showPlantColumn && !isViewing"
              caption="Dosis por planta"
              alignment="center"
            >
              <DxColumn
                v-if="isNew && showPlantColumn"
                caption="g/planta"
                data-field="dosagePlantKg"
                data-type="number"
                alignment="right"
                :allow-editing="false"
                :allow-sorting="false"
              />
              <DxColumn
                v-if="isNew && showPlantColumn"
                caption="ml/planta"
                data-field="dosagePlantL"
                data-type="number"
                alignment="right"
                :allow-editing="false"
                :allow-sorting="false"
              />
            </DxColumn>

            <DxColumn
              v-if="!isNew"
              :caption="$t('productResume.dosageTotal')"
              data-field="dosageTotal"
              data-type="number"
              alignment="center"
              :allow-editing="false"
              :allow-sorting="false"
            />
            <DxColumn
              v-if="showTotals"
              caption="Dosis Total"
              alignment="center"
            >
              <DxColumn
                v-if="solidProductFlag"
                caption="Kg"
                data-field="dosageTotalKg"
                data-type="number"
                alignment="right"
                :allow-editing="false"
                :allow-sorting="false"
              />
              <DxColumn
                v-if="liquidProductFlag"
                caption="L"
                data-field="dosageTotalL"
                data-type="number"
                alignment="right"
                :allow-editing="false"
                :allow-sorting="false"
              />
            </DxColumn>

            <DxColumn
              v-if="!isNew"
              :caption="$t('productResume.price')"
              data-field="price"
              alignment="center"
              data-type="number"
              :set-cell-value="setCellValue"
              :allow-sorting="false"
            />
            <DxColumn v-if="isNew" caption="Precio" alignment="center">
              <DxColumn
                caption="€/Kg"
                data-field="priceKg"
                alignment="right"
                data-type="number"
                :set-cell-value="setCellValue"
                :allow-sorting="false"
                :allow-editing="isViewing ? false : true"
              />
              <DxColumn
                caption="€/L"
                data-field="priceL"
                alignment="right"
                data-type="number"
                :set-cell-value="setCellValue"
                :allow-sorting="false"
                :allow-editing="isViewing ? false : true"
              />
            </DxColumn>

            <DxColumn
              :caption="
                stepData.nutritionIrrigationData.dosis_unit == 1
                  ? 'Coste unitario (€/ha)'
                  : 'Coste unitario (€/pie)'
              "
              data-field="costUnit"
              data-type="number"
              alignment="right"
              :allow-editing="false"
              :allow-sorting="false"
            />
            <DxColumn
              v-if="showPlantColumn"
              :caption="$t('nutritionDetail.productResume.costPlant')"
              data-field="costPlant"
              data-type="number"
              alignment="right"
              :allow-editing="false"
              :allow-sorting="false"
            />
            <DxColumn
              v-if="!isViewing || (showTotals && isViewing)"
              :caption="$t('productResume.costTotal')"
              data-field="costTotal"
              data-type="number"
              alignment="right"
              :allow-editing="false"
              :allow-sorting="false"
            />
            <DxSummary v-if="!isViewing" css-class="summary-table">
              <DxTotalItem
                column="costUnit"
                summary-type="sum"
                :customize-text="totalItem"
              />
              <DxTotalItem
                v-if="showPlantColumn"
                column="costPlant"
                summary-type="sum"
                :customize-text="totalItem"
              />
              <DxTotalItem
                column="costTotal"
                summary-type="sum"
                :customize-text="totalItem"
              />
            </DxSummary>
          </DxDataGrid>
        </section>
      </div>
    </div>
  </section>
</template>
<script>
import {
  DxColumn,
  DxDataGrid,
  DxEditing,
  DxSummary,
  DxTotalItem,
} from "devextreme-vue/data-grid";
import DxNumberBox from "devextreme-vue/number-box";
import { mapState, mapActions } from "vuex";
import plantationService from "@/services/plantationService";
import ProductDataFormatter from "@/pages/wizardNutrition/report-formatter/product-data-formatter";

export default {
  name: "ProductResume",
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxNumberBox,
    DxSummary,
    DxTotalItem,
  },
  props: {
    fertilization: {
      default: () => [],
    },
    plantationData: {
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      plantation: {},
      editingCell: null,
      productResume: [],
      liquidProductFlag: false,
      solidProductFlag: false,
    };
  },
  computed: {
    ...mapState("nutritionStepper", [
      "stepData",
      "enableWatchers",
      "isCopying",
      "isNew",
      "isViewing",
    ]),
    ...mapState("Plantation", ["currentPlantation"]),
    ...mapState("RegisterPlantation", ["actualPlantation"]),
    ...mapState("Nutrition", ["productsNotInNutritionPlan"]),
    showPlantColumn() {
      const cropTypeRaw = this.plantationData?.[0]?.crop_type;

      if (!cropTypeRaw) return true;

      const cropType = cropTypeRaw
        .trim()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

      return cropType !== "HERBACEO";
    },
    getArea() {
      const { value: area } =
        this.actualPlantation?.farms[0].properties.find(
          (prop) => prop.key === "area"
        ) || {};
      return this.fixNumberTo(area, 2);
    },
    mixedTypes() {
      return this.stepData.dosageProduct.some(
        (product) =>
          product.presentation === "SOLIDO" &&
          this.stepData.dosageProduct.some(
            (prod) => prod.presentation === "LIQUIDO"
          )
      );
    },
    getUnit() {
      // Dosis unit = 1 = Kg-L/ha, 2 = g-cm3/pie
      return this.stepData.nutritionIrrigationData.dosis_unit;
    },
    showTotals() {
      return this.stepData.nutritionIrrigationData.showTotals;
    },
  },
  watch: {
    "stepData.productResume": {
      handler(val) {
        if (val.length === 0) {
          return;
        }
        this.calcTotalCost(val);
      },
      deep: true,
    },
  },
  async beforeMount() {
    this.stepData.area = this.getArea;
    const plantationCompantId = this.isCopying
      ? this.currentPlantation.plantationCompanyId
      : this.currentPlantation.companyId;
    if (this.isViewing) {
      this.setProductsNotInNutritionPlan([]);
      const formatter = new ProductDataFormatter(this.fertilization);
      try {
        await formatter.buildProductResumeData();
      } catch (e) {
        const notFoundNutritionProducts = JSON.parse(e.message);
        this.setProductsNotInNutritionPlan(notFoundNutritionProducts);
      }
      this.productResume = formatter.productResume.map((p) => ({
        ...p,
        visiblePop: false,
      }));
    } else {
      await plantationService
        .getById(this.currentPlantation.id, plantationCompantId)
        .then(() => {
          this.stepData.productResume = this.stepData.dosageProduct.map(
            (product, index) => {
              const isSolid = product?.presentation === "SOLIDO";
              const plants_density = this.actualPlantation?.plants_density;

              const dosageUnit = this.roundValue(
                this.stepData.dosages[index]?.dosage || 0,
                1
              );
              // Total real introducido/calculado en la columna "Totales" (Kg o L
              // según presentación). No se recalcula desde dosageUnit * area: si el
              // usuario solo rellenó "Totales" para algún día, dosageUnit puede ser 0
              // y se perdería el dato (EDSER-2121).
              const totalAmount = this.roundValue(
                this.stepData.dosages[index]?.totalAmount || 0,
                1
              );
              const priceKg = this.stepData.productResume[index]?.priceKg || 0;
              const priceL = this.stepData.productResume[index]?.priceL || 0;

              let dosageUnitKg = 0;
              let dosageUnitL = 0;
              let dosagePlant = 0;
              let dosagePlantKg = 0;
              let dosagePlantL = 0;
              let dosageTotal = 0;
              let dosageTotalKg = 0;
              let dosageTotalL = 0;
              let costUnit = 0;
              let costPlant = 0;
              let costTotal = 0;
              if (this.stepData.nutritionIrrigationData.dosis_unit == 1) {
                dosageUnitKg = this.roundValue(
                  isSolid ? dosageUnit : dosageUnit * (product?.density || 1),
                  1
                );
                dosageUnitL = isSolid ? "" : dosageUnit;

                dosagePlant = this.roundValue(
                  (dosageUnit * 1000) / plants_density,
                  1
                );
                dosagePlantKg = this.roundValue(
                  (dosageUnitKg * 1000) / plants_density,
                  1
                );
                dosagePlantL = isSolid
                  ? ""
                  : this.roundValue((dosageUnitL * 1000) / plants_density, 1);
                dosageTotal = totalAmount;
                dosageTotalKg = this.roundValue(
                  isSolid ? totalAmount : totalAmount * (product?.density || 1),
                  1
                );
                dosageTotalL = isSolid ? "" : totalAmount;
              } else if (
                this.stepData.nutritionIrrigationData.dosis_unit == 2
              ) {
                if (isSolid) {
                  dosageUnitKg = dosageUnit;
                } else {
                  dosageUnitKg = this.roundValue(
                    dosageUnit * (product?.density || 1),
                    1
                  );
                  dosageUnitL = dosageUnit;
                  dosagePlantL = dosageUnit;
                  dosageTotalL = totalAmount;
                }
                dosagePlantKg = dosageUnitKg;
                // La columna "Totales" siempre se expresa en Kg o L según la
                // presentación del producto (independiente de si la dosis unitaria
                // está en kg/ha o g/pie), así que se convierte igual que en el otro modo.
                dosageTotalKg = this.roundValue(
                  isSolid ? totalAmount : totalAmount * (product?.density || 1),
                  1
                );

                if (!isSolid && priceL > 0) {
                  costUnit = this.roundValue((dosageUnitKg * priceL) / 1000, 2);
                  costTotal = this.roundValue(dosageTotalL * priceL, 2);
                } else {
                  costUnit = this.roundValue(
                    (dosageUnitKg * priceKg) / 1000,
                    2
                  );
                  costTotal = this.roundValue(dosageTotalKg * priceKg, 2);
                }
                costPlant = costUnit;
              }

              return {
                product: product.name,
                density: product.density,
                presentation: product.presentation,
                tipology: product.tipology,

                // Dosis
                dosageUnit,
                dosageUnitKg,
                dosageUnitL,
                // Dosis por planta
                dosagePlant,
                dosagePlantKg,
                dosagePlantL,
                // Dosis total
                dosageTotal,
                dosageTotalKg,
                dosageTotalL,

                price: this.stepData.productResume[index]?.price || 0,
                priceKg,
                priceL,

                costUnit,
                costPlant,
                costTotal,
              };
            }
          );
        });
      this.productResume = this.stepData.productResume.map((p) => ({
        ...p,
        visiblePop: false,
      }));
    }
    this.liquidProduct();
    this.solidProduct();
  },
  methods: {
    ...mapActions("Nutrition", ["setProductsNotInNutritionPlan"]),
    onEditingStart(e) {
      this.editingCell = e.column.dataField;
    },
    fixNumberTo(number, digits) {
      return parseFloat(parseFloat(number).toFixed(digits));
    },
    setCellValue(newData, value, currentRowData) {
      // Actualiza el valor editado en la celda
      newData[this.editingCell] = parseFloat(Math.abs(value).toFixed(2));

      // Busca el producto correspondiente y actualiza también en stepData.productResume
      const idx = this.productResume.findIndex(
        (p) => p.product === currentRowData.product
      );
      if (idx !== -1) {
        this.productResume[idx][this.editingCell] = newData[this.editingCell];
        if (this.stepData.productResume && this.stepData.productResume[idx]) {
          this.stepData.productResume[idx][this.editingCell] =
            newData[this.editingCell];
        }
      }

      // Recalcula los costes con los datos actualizados
      this.calcTotalCost(this.productResume);
    },
    onCellPreparedViewing(e) {
      if (e.rowType === "data") {
        if (e.rowIndex !== this.productResume.length - 1) return;
        e.cellElement.style.backgroundColor = "var(--fr-chocolat)";
        e.cellElement.style.borderTop = "2px solid #ddd";
        e.cellElement.style.fontWeight = "600";
      }
    },
    onCellPrepared(e) {
      const isLiquid = e.data?.presentation === "LIQUIDO";
      const isSolid = e.data?.presentation === "SOLIDO";

      // Liquid products have both prices(kg and l) enabled but only one can be filled.
      if (
        isLiquid &&
        e.rowType === "data" &&
        (e.column.dataField === "priceKg" || e.column.dataField === "priceL")
      ) {
        if (e.column.dataField === "priceKg" && e.data.priceL > 0) {
          e.cellElement.style.backgroundColor = "#D9D9D9";
          e.cellElement.style.border = "1px solid #c0c9ce";
          e.cellElement.style.pointerEvents = "none";

          e.data.priceKg = 0;
        }

        if (e.column.dataField === "priceL" && e.data.priceKg > 0) {
          e.cellElement.style.backgroundColor = "#D9D9D9";
          e.cellElement.style.border = "1px solid #c0c9ce";
          e.cellElement.style.pointerEvents = "none";

          e.data.priceL = 0;
        }
      }

      // Solid products have one price(kg) enabled.
      if (isSolid && e.rowType === "data" && e.column.dataField === "priceL") {
        e.cellElement.style.backgroundColor = "#D9D9D9";
        e.cellElement.style.border = "1px solid #c0c9ce";
        e.cellElement.style.pointerEvents = "none";
      }

      if (
        e.rowType === "data" &&
        e.column.dataField !== "priceKg" &&
        e.column.dataField !== "priceL"
      ) {
        e.cellElement.style.backgroundColor = "#D9D9D9";
        e.cellElement.style.border = "1px solid #c0c9ce";
      }
    },
    calcTotalCost(element) {
      if (!this.enableWatchers) {
        return;
      }
      element.forEach((item) => {
        const selectedPrice = item.priceKg > 0 ? item.priceKg : item.priceL;
        const selectedDosage =
          item.priceKg > 0 ? item.dosageUnitKg : item.dosageUnitL;
        // Cantidad total real (Kg o L) para el precio seleccionado. El coste
        // total NO se puede derivar de "coste unitario * área/nº plantas":
        // en modo "Totales" el usuario puede no haber introducido dosis por
        // hectárea (dosageUnitKg/L = 0) y se perdería el coste total aunque
        // sí exista una cantidad total real (EDSER-2121).
        const selectedTotal =
          (item.priceKg > 0 ? item.dosageTotalKg : item.dosageTotalL) || 0;
        const isSolid = item.presentation === "SOLIDO";
        let calcCostUnit = 0;
        let calcCostPlant = 0;
        let calcCostTotal = 0;
        let numPlants = this.actualPlantation.plants || 1;
        let plants_density = this.actualPlantation.plants_density || 1;

        if (this.stepData.nutritionIrrigationData.dosis_unit == 1) {
          // 1. Calcula el coste unitario (€/ha)
          calcCostUnit = this.roundValue(selectedDosage * selectedPrice, 1);
          // 2. Calcula el coste total a partir de la cantidad total real
          calcCostTotal = this.roundValue(selectedTotal * selectedPrice);
          // 3. Calcula el coste por planta usando el nuevo coste total
          calcCostPlant = this.roundValue(calcCostTotal / numPlants, 2);
        } else {
          // 1. Calcula el coste unitario
          if (!isSolid && item.priceL > 0) {
            calcCostUnit = this.roundValue(
              (item.dosagePlantL * item.priceL) / 1000,
              2
            );
          } else {
            calcCostUnit = this.roundValue(
              (item.dosagePlantKg * item.priceKg) / 1000,
              2
            );
          }
          // 2. Calcula el coste por planta
          calcCostPlant = calcCostUnit;
          // 3. Calcula el coste total a partir de la cantidad total real
          calcCostTotal = this.roundValue(selectedTotal * selectedPrice);
        }

        // Validaciones
        if (Number.isNaN(calcCostUnit) || !Number.isFinite(calcCostUnit)) {
          calcCostUnit = 0;
        }
        if (Number.isNaN(calcCostPlant) || !Number.isFinite(calcCostPlant)) {
          calcCostPlant = 0;
        }
        if (Number.isNaN(calcCostTotal) || !Number.isFinite(calcCostTotal)) {
          calcCostTotal = 0;
        }

        item.costUnit = this.roundValue(calcCostUnit, 2);
        item.costPlant = this.roundValue(calcCostPlant, 2);
        item.costTotal = parseInt(calcCostTotal, 10);
      });
    },
    roundValue(val, decimals = 2) {
      return parseFloat(val.toFixed(decimals));
    },
    totalItem(data) {
      const value = parseFloat(data.value.toFixed(2));
      return `Total: ${value}`;
    },
    solidProduct() {
      if (this.isViewing) {
        this.solidProductFlag = this.productResume.some(
          (product) => product.presentation === "SOLIDO"
        );
      } else {
        this.solidProductFlag = this.stepData.dosageProduct.some(
          (product) => product.presentation === "SOLIDO"
        );
      }
    },
    liquidProduct() {
      if (this.isViewing) {
        this.liquidProductFlag = this.productResume.some(
          (product) => product.presentation === "LIQUIDO"
        );
      } else {
        this.liquidProductFlag = this.stepData.dosageProduct.some(
          (product) => product.presentation === "LIQUIDO"
        );
      }
    },
  },
};
</script>
<style src="./productResume.scss" scoped lang="scss"></style>
